import { Controller, Body, Post, Req } from '@nestjs/common';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { ApiTags } from '@nestjs/swagger';
import { ComplaintsDTO } from './dto/complaints.dto';
import { ComplaintsService } from './complaints.service';
import { AllComplaintsResponseModel, ComplaiintsResponseModel } from '@gtpl/shared-models/hrms';
import { ComplaintsRequest } from './dto/complaints.request';
@Controller('complaints')
export class ComplaintsController {
    
    constructor(
        private service: ComplaintsService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
    ){}

    @Post('/createComplaint')
    async createComplaint(@Body() dto: ComplaintsDTO): Promise<ComplaiintsResponseModel>{
        try{
            return await this.service.createComplaint(dto, false);
        }catch(error){
            return this.applicationExceptionHandler.returnException(ComplaiintsResponseModel, error);
        }
    }

    @Post('/updateComplaint')
    async updateComplaint(@Body() dto: ComplaintsDTO): Promise<ComplaiintsResponseModel>{
        try{
            return await this.service.createComplaint(dto, true);
        }catch(error){
            return this.applicationExceptionHandler.returnException(ComplaiintsResponseModel, error);
        }
    }

    @Post('/getAllComplaints')
    async getAllComplaints(): Promise<AllComplaintsResponseModel>{
        try{
            return await this.service.getAllComplaints();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllComplaintsResponseModel, error);
        }
    }

    @Post('/activateOrDeactivateComplaint')
    async activateOrDeactivateComplaint(@Body() req: ComplaintsRequest): Promise<ComplaiintsResponseModel>{
        try{
            return await this.service.activateOrDeactivateComplaint(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(ComplaiintsResponseModel, error);
        }
    }
}
